import React from "react";
import PropTypes from "prop-types";
import { Row } from "jsxstyle";
import Table from "components/Table";
import Button from "components/Button";
import Separator from "components/Separator";
import DeleteCLORatingAgency from "./DeleteCLORatingAgency";
import PermissionValidator from "components/PermissionValidator";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";

function CLORatingAgenciesTable({ data, pending, onReload, onRequestEdit }) {
  const handleOnChange = (pagination, filter, sorter) => {};

  return (
    <PermissionValidator
      allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}
      shouldHide={false}
    >
      {({ isAllowed }) => (
        <Table
          data={data}
          onChange={handleOnChange}
          pending={pending}
          rowKey="id"
          columns={[
            {
              title: "Agency",
              dataIndex: "entity_id.editorial_name",
              key: "entity_id.editorial_name"
            },
            // CLORatingAgenciesTable
            ...(isAllowed
              ? [
                  {
                    title: "Actions",
                    dataIndex: "",
                    key: "",
                    width: 100,
                    render: item => (
                      <Row>
                        <Button
                          icon="edit"
                          onClick={() => onRequestEdit(item)}
                        />
                        <Separator />
                        <DeleteCLORatingAgency
                          rating={item}
                          onDelete={onReload}
                        />
                      </Row>
                    )
                  }
                ]
              : [])
          ]}
        />
      )}
    </PermissionValidator>
  );
}

CLORatingAgenciesTable.propTypes = {
  data: PropTypes.array,
  pending: PropTypes.bool,
  onReload: PropTypes.func.isRequired,
  onRequestEdit: PropTypes.func.isRequired
};

CLORatingAgenciesTable.defaultProps = {
  data: [],
  pending: false
};

export default CLORatingAgenciesTable;
